import { render, staticRenderFns } from "./HomeAboutUs.vue?vue&type=template&id=1c48c7ce&scoped=true"
import script from "./HomeAboutUs.vue?vue&type=script&lang=js"
export * from "./HomeAboutUs.vue?vue&type=script&lang=js"
import style0 from "./HomeAboutUs.vue?vue&type=style&index=0&id=1c48c7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48c7ce",
  null
  
)

export default component.exports